<template>
  <div title="Astron Members">
    <div class="mb-6">
      <h5 class="text-semibold">Astron Members</h5>
      <small>
        Integre sua área de membros da plataforma Astron Members ao ZeusPay
      </small>
    </div>
    <snow-data-table-header
      @add="add"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <template v-else>
      <snow-data-table :data="integrationList" :columns="membersColumns">
        <template #url-de-desativacao="{ item }">
          <div class="d-flex">
            <snow-button variant="borderless" size="sm" @click="copyUrl(item)">
              <i class="ph ph-link" />
            </snow-button>
            <snow-button variant="borderless" size="sm" @click="openUrl(item)">
              <i class="ph ph-arrow-square-out" />
            </snow-button>
          </div>
        </template>
        <template #no-content-actions>
          <snow-button
            icon="ph ph-plus"
            text="Adicionar integração"
            @click="modal = true"
          />
        </template>
      </snow-data-table>
      <div class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </template>

    <integration-modal
      v-model="modal"
      :isEdit="!!integrationToEdit"
      title="Astron Members"
      link="https://www.astronmembers.com.br/"
    >
      <astron-modal
        :integrationToEdit="integrationToEdit"
        @close="modal = false"
        @update-list="dispatch"
      />
    </integration-modal>
  </div>
</template>
<script>
import AstronModal from "@/components/tools/modals/member-area/Astron.vue";
import { TRANSLATE_FIELD_INTEGRATION_MAP } from "@/constants/fields.js";
import IntegrationsMixin from "@/mixins/integration.js";

export default {
  mixins: [IntegrationsMixin],
  components: {
    AstronModal
  },
  data: () => ({
    integration: "astron",
    breadcrumbs: [
      { title: "Ferramentas", link: "tools" },
      { title: "Área de membros", link: "tools-member-area" },
      { title: "Astron Members" }
    ]
  }),
  computed: {
    membersColumns() {
      return [
        {
          name: "Produto",
          field: "product",
          transform: value => value?.name || ""
        },
        {
          name: "Descrição",
          field: "description",
          transform: v => this.formatLongText(v)
        },
        {
          name: "URL de desativação",
          field: "url"
        },
        {
          name: "Status",
          field: "status",
          transform: value => (value ? "Ativo" : "Inativo"),
          color: value => (value ? "green" : "negative"),
          type: "tag"
        },
        {
          type: "menu",
          options: this.actions
        }
      ];
    }
  },
  methods: {
    actions(item) {
      return [
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: item.status ? "Desativar" : "Ativar",
          class: item.status ? "text-danger" : "text-success",
          click: this.changeStatus
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text:
              "Deseja mesmo excluir esta integração? Não enviaremos mais os leads para esta segmentação.",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            action: this.submitDelete,
            secondaryButtonText: "Não, cancelar"
          }
        }
      ];
    },
    changeStatus(item) {
      let data = { ...item, status: !item.status, product_id: item.product.id };
      this.$store
        .dispatch("integration/postIntegration", data)
        .then(data => {
          this.$message.success(
            `Integração ${!data.status ? "ativada" : "desativada"}`
          );
          this.refresh();
        })
        .catch(error => {
          let msg = get_error_msg(
            error.response.data,
            TRANSLATE_FIELD_INTEGRATION_MAP,
            "Não foi possível alterar o status da integração"
          );
          this.$message.error(msg);
        });
    }
  }
};
</script>
